/** @format */

import React from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  walkinEnquiryCreate,
  walkinFollowupCreate,
} from "../../data/ApiEndpoints";
import Select from "react-select";
import moment from "moment";
import { useCreateFetch } from "../../data/Queries";
import { toast } from "react-toastify";

const AddFollowup = ({ userForm, userDetails, token, next, refetchEnq }) => {
  const { mutateAsync: createEnquiry } = useCreateFetch({
    url: walkinEnquiryCreate,
    key: walkinEnquiryCreate,
    token,
  });
  const { mutateAsync: createFollowup } = useCreateFetch({
    key: walkinFollowupCreate,
    url: walkinFollowupCreate,
    token,
  });
  const validationSchema = Yup.object().shape({
    followUpStatus: Yup.object().required("This is Required*"),
    nextFollowupDateTime: Yup.string()
      .required("This is Required*")
      .test(
        "is-future-date",
        "Date/Time must be at least 30 minutes after current time",
        function (value) {
          const selectedDate = new Date(value);
          const currentDate = new Date();
          const minFutureDate = new Date(currentDate.getTime() + 29 * 60000);
          return selectedDate > minFutureDate;
        }
      ),
    remarks: Yup.string().required("This is Required*"),
  });

  const formik = useFormik({
    initialValues: {
      followUpStatus: "",
      nextFollowupDateTime: "",
      remarks: "",
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      const enqBody = {
        user_name: userForm?.name,
        mobile: userForm?.mobile,
        gym_id: userForm?.gym_id,
        status: "active",
        remarks: values?.remarks,
        enq_status: "pending",
        customer_type: userForm?.customer_type,
        user_id: userDetails?.uid,
      };

      const { data, status } = await createEnquiry(enqBody);
      if (status) {
        refetchEnq();
        const body = {
          added_by: userDetails?.uid,
          walk_in_id: data[0]?.uid,
          gym_id: userForm?.gym_id,
          follow_up_status: values?.followUpStatus?.value,
          scheduled_on: formatDateTime(new Date()),
          poc_comment: "",
          remark_current: values?.remarks,
          next_follow_up_date: formatDateTime(values?.nextFollowupDateTime),
          first_follow_up_schedule: "",
        };
        const body2 = {
          added_by: userDetails?.uid,
          walk_in_id: data[0]?.uid,
          gym_id: userForm?.gym_id,
          follow_up_status: values?.followUpStatus?.value,
          scheduled_on: formatDateTime(values?.nextFollowupDateTime),
          poc_comment: "",
          remark_current: values?.remarks,
          next_follow_up_date: "",
          first_follow_up_schedule: "",
        };
        const { status, message } = await createFollowup(body);
        const { status: status2, message: message2 } = await createFollowup(
          body2
        );
        if (status) {
          toast.success(message);
        } else {
          toast.error(message);
        }
        if (status2) {
          toast.success(message2);
        } else {
          toast.error(message2);
        }

        if (status && status2) {
          next();
        }
      }
    },
  });

  const statusOpt = [
    // { label: "Did Not Pick Up", value: "did_not_pick_up" },
    { label: "Rescheduled", value: "rescheduled" },
    // { label: "Switched Off", value: "switched_off" },
    // { label: "Other", value: "other" },
  ];

  function formatDateTime(dateTime) {
    return moment(dateTime).tz("Asia/Kolkata").format("YYYY-MM-DD HH:mm");
  }

  return (
    <form onSubmit={formik.handleSubmit}>
      <div className="grid-k grid-col-2-k timer-wrapper my-4 gap-1-k">
        <div>
          <label htmlFor="followUpStatus">Follow Up Status:</label>
          <Select
            classNamePrefix="input-k-select"
            placeholder="Select Status.."
            id="followUpStatus"
            name="followUpStatus"
            value={formik.values.followUpStatus}
            onChange={(selectedOption) =>
              formik.setFieldValue("followUpStatus", selectedOption)
            }
            options={statusOpt}
          />
          {formik.errors.followUpStatus && formik.touched.followUpStatus && (
            <div className="error-message">{formik.errors.followUpStatus}</div>
          )}
        </div>

        <div>
          <label htmlFor="nextFollowupDateTime">Next Followup Date/Time:</label>
          <input
            type="datetime-local"
            id="nextFollowupDateTime"
            className="input-k"
            name="nextFollowupDateTime"
            value={formik.values.nextFollowupDateTime}
            onChange={formik.handleChange}
          />
          {formik.errors.nextFollowupDateTime &&
            formik.touched.nextFollowupDateTime && (
              <div className="error-message">
                {formik.errors.nextFollowupDateTime}
              </div>
            )}
        </div>

        <div>
          <label htmlFor="remarks">Remarks:</label>
          <textarea
            className="input-k text-area-k"
            id="remarks"
            name="remarks"
            placeholder="Describe.."
            value={formik.values.remarks}
            onChange={formik.handleChange}
          />
          {formik.errors.remarks && formik.touched.remarks && (
            <div className="error-message">{formik.errors.remarks}</div>
          )}
        </div>

        <div className="flex-k js-end-k items-end-k">
          <button type="submit" className="btn-k btn-primary-k large">
            Submit
          </button>
        </div>
      </div>
    </form>
  );
};

export default AddFollowup;
